const UPDATE_LIST = '@@leaves/UPDATE_LIST';

const UPDATE_PINNED = '@@leaves/UPDATE_PINNED';

const UPDATE_DETAILS = '@@leaves/UPDATE_DETAILS';

const UPDATE_HISTORY = '@@leaves/UPDATE_HISTORY';

const CLEAR_LIST = '@@leaves/CLEAR_LIST'

const UPDATE_MISSED_FILTER = '@@leaves/UPDATE_MISSED_FILTER'

const CLEAR_MISSED_FILTER = '@@leaves/CLEAR_MISSED_FILTER'

const UPDATE_PENDING_FILTER = '@@leaves/UPDATE_PENDING_FILTER'

const CLEAR_PENDING_FILTER = '@@leaves/CLEAR_PENDING_FILTER'

const UPDATE_FILTER = '@@leaves/UPDATE_FILTER'

const CLEAR_FILTER = '@@leaves/CLEAR_FILTER'

export default {
	UPDATE_LIST,
	UPDATE_PINNED,
	UPDATE_DETAILS,
	CLEAR_LIST,
	UPDATE_HISTORY,
	UPDATE_MISSED_FILTER,
	CLEAR_MISSED_FILTER,
	UPDATE_PENDING_FILTER,
	CLEAR_PENDING_FILTER,
	UPDATE_FILTER,
	CLEAR_FILTER
};
